var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-not-found"}},[_vm._v(" Page not found :( ")])}
var staticRenderFns = []

export { render, staticRenderFns }